<template>
  <div id="app" @click="handleBodyClick($event)">
    <div class="main-content">
      <NavBar />
      <router-view ref="content" />
    </div>
    <div class="copy-right">
      <span class="float-right">copyright (c) 2020 Simavita</span>
    </div>
    <!-- <CookieBox /> -->
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
// import CookieBox from './CookieBox.vue'
import $ from 'jquery'
export default {
  name: 'layout',
  components: {
    NavBar
    // CookieBox
  },
  mounted: function() {
    let allowCookie = localStorage.getItem('smartz-cookie')
    if (!allowCookie) {
      $('.cookie-content-wrap').show()
    } else {
      $('.cookie-content-wrap').hide()
    }
  },
  methods: {
    //Dismiss the popover by clicking outside
    handleBodyClick(e) {
      if (
        $(e.target).data('toggle') !== 'popover' &&
        $(e.target).parents('.popover.in').length === 0
      ) {
        this.$root.$emit('bv::hide::popover')
      }
    }
  }
}
</script>
